﻿import type { RouteRecordRaw } from 'vue-router'

const shareholderRoutes: RouteRecordRaw = {
  path: '/shareholder',
  name: 'Shareholder',
  redirect: '/shareholder/profile',
  meta: { title: '股东股权管理', icon: 'icon-user' },
  children: [
    { path: 'profile', name: 'ShareholderProfile', component: () => import('@/views/shareholder/ProfileList.vue'), meta: { title: '股东档案', permissions: ['shareholder:profile:view'] } },
    { path: 'change', name: 'ShareholderChange', component: () => import('@/views/shareholder/ChangeList.vue'), meta: { title: '股权变更', permissions: ['shareholder:change:view'] } },
    { path: 'dividend', name: 'ShareholderDividend', component: () => import('@/views/shareholder/DividendList.vue'), meta: { title: '分红管理', permissions: ['shareholder:dividend:view'] } },
  ],
}

export default shareholderRoutes
